import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {RequestControllerService} from '../../services/request-controller.service';
import {Request} from '../../models/request';
import {UtilityService} from '../../utility.service';
import {InformationFieldsControllerService} from '../../services/information-fields-controller.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {PreConfiguration} from '../../models/pre-configuration';
import {LocationStrategy} from '@angular/common';
import {TranslatePipe} from '../../translation/translate.pipe';
import {ProtocolDialogComponent} from '../protocol-dialog/protocol-dialog.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})

export class ListComponent implements OnInit {
  displayedColumns: string[] = ['name', 'assetType', 'fileCategory', 'validTill',
    'validity', 'maxFiles', 'creatorUsername', 'share', 'actions', 'valid'];
  dataSource;
  nodeId: number;
  assetTypesMap = [];
  loading = false;
  filterValue;
  fileToUpload: File | null = null;
  @ViewChild('importForm', {static: false})
  importForm;
  @ViewChild('importFormTemplate', {static: false})
  importFormTemplate;
  nodeIds;
  preConfiguration: PreConfiguration;

  constructor(private requestService: RequestControllerService,
              private utilityService: UtilityService,
              private infoFieldsService: InformationFieldsControllerService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              public confirmationDialog: MatDialog,
              private locationStrategy: LocationStrategy,
              public translatePipe: TranslatePipe,
              public protocolDialog: MatDialog) {}

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.requestService.getConfigUsingGET().subscribe(configuration => {
      this.preConfiguration = configuration;
    });
    this.activatedRoute.queryParams.subscribe(params => {
      this.nodeIds  = params['nodeIds'];
      if (!this.nodeIds) {
        this.displayedColumns = ['name', 'assetType', 'fileCategory', 'maxFiles', 'validTill',
          'creatorUsername', 'targetNode', 'share', 'actions', 'valid'];
      }
    });
    this.loading = true;
    this.nodeId = this.utilityService.getNodeId();
    this.infoFieldsService.assetTypesUsingGET().subscribe(assetTypes => {
      assetTypes.forEach(assetType => {
        this.assetTypesMap[assetType.id.id] = assetType;
      });
      if (this.nodeId != null) {
        this.requestService.listNodeRequestsUsingGET(this.nodeId).subscribe(res => {
          if (res.length < 1) {
            this.router.navigate(['main/uploadRequest/config/create'], {
              queryParams: {
                nodeIds: this.nodeId,
                firstRequest: true
              },
              queryParamsHandling: 'merge'
            });
          } else {
            const requests = [];
            res.forEach(request => {
              requests.push(this.createRequestData(request));
            });
            this.dataSource = new MatTableDataSource(requests);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.loading = false;
          }
        });
      } else {
        this.requestService.listRequestsUsingGET().subscribe(res => {
          if (res.length < 1) {
            this.router.navigate(['main/uploadRequest/config/create'], {
              queryParams: {
                nodeIds: this.nodeId,
                firstRequest: true
              },
              queryParamsHandling: 'merge'
            });
          } else {
            const requests = [];
            res.forEach(request => {
              requests.push(this.createRequestData(request));
            });
            this.dataSource = new MatTableDataSource<Request>(requests);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.loading = false;
          }
        });
      }
    });
  }


  applyFilter() {
    const filterValue = this.filterValue;
    if (filterValue !== undefined) {
      this.dataSource.filter = filterValue;
      this.dataSource.sort = this.sort;
    }
  }

  applyValidityFilter() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      return data.validTill == null || data.validTill > new Date().getTime();
    };
  }

  deleteRequest(id: string, element) {
    this.requestService.deleteRequestUsingDELETE(id).subscribe(res => {
      this.removeRequestFromList(element);
    });
  }

  openConfirmationDialog(id, template) {
    const confirmationDialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {width: '500px'});
    confirmationDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteRequest(id, template);
      }
    });
  }

  removeRequestFromList(request) {
    const index = this.dataSource.data.indexOf(request);
    this.dataSource.data.splice(index, 1);
    this.dataSource._updateChangeSubscription();
  }

  copyLinkToClipboard(element) {
    const link = element.authenticationMode === 'CELUM_LOGIN' ?
      '/main/uploadRequest/request/' + element.id : '/uploadRequest/request/' + element.id;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = location.origin + link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  mailTo(element) {
    const link = element.authenticationMode === 'CELUM_LOGIN' ?
      '/main/uploadRequest/request/' + element.id : '/uploadRequest/request/' + element.id;
    window.location.href = 'mailto:?subject=' + element.name + '&body=' + location.origin + link;
  }

  createRequestData(request) {
    return {
      id: request.id,
      name: request.configuration ? request.configuration.name : '',
      assetType: (request.configuration.assetType != null && this.assetTypesMap[request.configuration.assetType]) ?
        this.assetTypesMap[request.configuration.assetType].name : '',
      fileCategory: request.configuration.fileCategory,
      maxFiles: request.configuration.maxFiles,
      validTill: request.configuration.validTill,
      valid: request.configuration.validTill == null || request.configuration.validTill > new Date().getTime(),
      validity: (request.configuration.validTill == null || request.configuration.validTill > new Date().getTime()) ?
        this.translatePipe.transform('VALID') : this.translatePipe.transform('INVALID'),
      authenticationMode: request.configuration.authenticationMode,
      targetNode: request.targetNode.id,
      creatorUsername: request.creatorUsername
    };
  }

  exportRequest(id) {
    window.opener.location = '../uploadRequest/requests/export/' + id;
  }

  openNodeLink(url) {
    parent.window.open(url).focus();
  }


  handleFileInput(event: Event) {
    this.importForm.nativeElement.submit();
  }

  handleFileInputTemplate(event: Event) {
    this.importFormTemplate.nativeElement.submit();
  }

  exportRequests() {
    if (this.nodeId) {
      window.opener.location = '../uploadRequest/requests/exportList/' + this.nodeId;
    } else {
      window.opener.location = '../uploadRequest/requests/exportList';
    }
  }

  openProtocol(request) {
    const protocolDialogRef = this.protocolDialog.open(ProtocolDialogComponent, {width: '500px'});
  }

}



